export default "__VITE_ASSET__Az8D1R2d__"